import React from "react";
// import { ResponsiveDatePickers } from "../../component/Elements/Date";
// import { BasicTimePicker } from "../../component/Elements/Timer";
// import moment from "moment";
// import svgImage from "../../Assets/Images/svgImages";
import {
  FormControl,
  Button,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
  FormControlLabel,
  styled,
  Grid,
  Checkbox,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Box } from "@mui/system";
import pakage from "../../Assets/Images/Group (3).png";
import emoji from "../../Assets/Images/g105 (1).png";
import disability1 from "../../Assets/Images/disability.png";
// import ModalFullscreenExample from "../../component/ModelEdit";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState, useEffect, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate, useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import dayjs from "dayjs";
import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
// import { UseSelector, useSelector } from "react-redux/es/hooks/useSelector";
import {
//   StandaloneSearchBox,
//   LoadScript,
//   useJsApiLoader,
  Autocomplete,
} from "@react-google-maps/api";
import AgentSubChild from "./AgentSubChild";
import SubChild from "../SubChild";
import EditAgentSubChild from "./EditAgentSubChild";
import { paths } from "../../config/constants";

import { useLocation } from "react-router-dom";
import utc from 'dayjs/plugin/utc';
import { MobileDateTimePicker } from "@mui/x-date-pickers";
import Scorpio from "../../Assets/Images/Scorpio.jpg"
import user from "../../Assets/Images/user1.png";
import bag from "../../Assets/Images/bag1.png";
import { useDispatch, useSelector } from "react-redux";

dayjs.extend(utc);
// const { GernamySvg } = svgImage;
const AddressFormWrapper = styled("form")({
  fieldset: {
    borderWidth: 0,
  },
  ".content-fields": {
    border: "1px solid #E6E6E6",
    padding: "10px",
  },
  ".MuiOutlinedInput-notchedOutline": {
    borderWidth: "0 !important",
  },
  ".Button": {
    backgroundColor: "#0E4672",
    color: "white",
  },
  ".Button:hover": {
    backgroundColor: "#0E4672",
    color: "white",
  },
  ".css-1ymdq6l-MuiFormLabel-root-MuiInputLabel-root": {
    fontFamily: "DM Sans",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#455E72"
  },
  ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
    fontFamily: "DM Sans",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "27px",
    color: "#1F3648",
    padding: "10px 14px"
  },
})
export default function EditBussinessBooking() {
  const location = useLocation();
  const { id, paymentType } = location.state || {};
    const navigate = useNavigate();
    // const { isLoaded, loadError } = useJsApiLoader({
    //     id: "google-map-script",
    //     googleMapsApiKey: "AIzaSyBBg22tDfYz76mPhudqsReP2bL9aYjOjsY",
    //     // libraries:["drawing","places"],
    //     // libraries: [],
    // });
    
    const [loading, setLoading] = useState(false);
    const [vehicleData, setVehicleData] = useState([]);
    const [fromLocation, setFromLocation] = useState("");
    const [toLocation, setToLocation] = useState("");
    const [errorfromLocation, setErrorFromLocation] = useState("");
    const [errortoLocation, setErrorToLocation] = useState("");
    
//   const authget = useSelector((state) => state.login.user);
//   const dispatch = useDispatch();
//   const reduxdata = useSelector((state) => state);
//   let bookingId = reduxdata.homeReducer.bookingId;
//   const [pickDate, setPickDate] = useState(dayjs());
//   const [distance, setDistance] = useState("");
//   const [duration, setDuration] = useState("");
//   const [show, setShow] = useState(false);
//   const [error, setError] = useState(false);
//   const [timee, setTimee] = useState("");
//   const dateString = datee;
//   const milliseconds = new Date(dateString).getTime();
//   const millisecondsRet = new Date(returnDatee).getTime();
//   const [extraOption, setExtraOption] = useState();
//   const [babySeatCount, setBabySeatCount] = useState(0);
//   const [childSeatCount, setChildSeatCount] = useState(0);
//   const [boosterSeatCount, setBoosterSeatCount] = useState(0);
//   const [sliber, setSliber] = useState(0);
//   const [gold, setGold] = useState(0);
//   const [platinum, setPlatinum] = useState(0);
//   const [wheelchair, setWheelchair] = useState(0);
//   const [showGeoMaps, setShowGeoMaps] = useState(false);
//   const nav = useNavigate();

  const [response, setResponse] = useState("");
  const minDate = dayjs().add(0, "day");
  const maxDate = dayjs().add(1, "month");
  const [datee, setDatee] = useState(minDate);
  const [returnDate, setReturnDate] = useState();
  const [bookingId, setBookingId] = useState(id);
  const [childSeat, setChildSeat] = useState();
  const [packages, setPackages] = useState();
  const [extra, setExtra] = useState("");
  const [journey, setJourney] = React.useState("");
  const [vechicleType, setVehicleType] = React.useState("");
  const [journeyType, setJourneyType] = useState();
  const [distanceKm, setDistanceKM] = useState();
  const [pickUpDate, setPickupDate] = useState();
  const [duration1, setDuration1] = useState();
  const [route, setRoute] = useState();
  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");
  const [email, setEmail] = useState("");
  const [numbers, setNumbers] = useState("");
  const [address, setAddress] = useState("");
  const [comment, setComment] = useState("");
  const [fare, setFare] = useState("");
  const [errors, setErrors] = useState({});
  const [errorDetails, setErrorDetails] = useState({});
  const [showGeoMaps, setShowGeoMaps] = useState(false);
  const [showGeoMaps2, setShowGeoMaps2] = useState(true);
  const[minDateTime,setMinDateTime]=useState(dayjs.utc());
    const [childSeatTotal, setChildSeatTotal] = useState(0);
    const [packagesTotal, setPackagesTotal] = useState(0);
    const [extraTotal, setExtraTotal] = useState(0);
    //const [globalNumberSum, setGlobalNumberSum] = useState(0); // Store sum in state
    const [prevServ,setPrevServ]=useState("");
    const [vahicalInfo, setVahicalInfo] = useState([]);
    const[taxApplied,setTaxApplied]=useState(0)
    const[flightNum,setFlightNum]=useState(0);
    const[returnFlightNum,setReturnFlightNum]=useState(0);
    const[extraTime,setExtraTime]=useState("")
    const[returnExtraTime,setReturnExtraTime]=useState("")
    const[minDatee,setMinDatee]=useState(dayjs());
    const[bookingExtraTotal,setBookingExtraTotal]=useState(0);
    const[bookingExtraTaxAm,setBookingExtraTaxAm]=useState(0);
    const[bookingExtraWithoutTax,setBookingExtraWithoutTax]=useState(0);
    const[rideChargesTaxAm,setRideChargesTaxAm]=useState(0);
    const[rideChargesWithoutTax,setRideChargesWithoutTax]=useState(0);
    const[rideCharges,setRideCharges]=useState(0);
    const[Subtotal,setSubTotal]=useState(0)
    const[totalTax,setTotalTax]=useState(0)
    const role = localStorage.getItem("userRole");
    const accountType = localStorage.getItem("accountType");
    const _userId = localStorage.getItem("_id");    
    const [priceRuleApplied, setPriceRuleApplied] = useState("");
    const roleFName = localStorage.getItem("fname");
    const roleLName = localStorage.getItem("lname");

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [bookingNo,setBookingNo]=useState("")
    const [checked, setChecked] = useState(false)
    const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  const [taxNumber, setTaxNumber] = useState();
  const [taxNumberErrorText, setTaxNumberErrorText] = useState("");
  const [country, setCountry] = useState();
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]); 
  const [city, setCity] = useState("");
  const [stateRegion, setStateRegion] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [postal, setPostal] = useState("");
  const [countryName, setCountryName] = useState("");
  const [stateName, setStateName] = useState("");
  const[passengers,setPassengers]=useState("")
  const[returnPassengers,setReturnPassengers]=useState("")
  const [selectedVehicleCapacity,setSelectedVehicleCapacity]=useState()
  const [groupedVehicles, setGroupedVehicles] = useState({});
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);
  const [loadingTwo, setLoadingTwo] = useState(true);
  const [quoteDialog, setQuoteDialog] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [toLocationCoords, setToLocationCoords] = useState("");
  const [fromLocationCoords, setFromLocationCoords] = useState("");
  const [selectedChildSeats, setSelectedChildSeats] = useState({});
  const [selectedPackages, setSelectedPackages] = useState({});
  const [selectedExtras, setSelectedExtras] = useState({});
  const [totalFare, setTotalFare] = useState("");
  const [totalReturnFare, setTotalReturnFare] = useState("");
  const [cancelStatus,setCancelStatus] = useState("")
  const reduxdata = useSelector((state) => state);

  const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        vehicleCategory: "",
        vehicleCapacity: "",
        luggageCapacity: "",
        pickupAddress: reduxdata.homeReducer.from,
        dropoffAddress: reduxdata.homeReducer.to,
      });
  
  const fNameRef = useRef(null);
  const lNameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };


  useEffect(() => {
    fetchCountryList();
  }, []);

  const fetchCountryList = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}api/booking/getCountriesList`
      );
      setCountryList(res?.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  
  useEffect(() => {
    // setCity("");
    if(country !== ""){
      getStateList();
      getCityList();
    }
  }, [country])

  useEffect(() => {
    if(stateRegion!== "")
    {
      getCityList();
    }
  }, [stateRegion])



 const getStateList = async (e) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getStateList`, 
        { countryCode: country }
      );
      setStateList(response?.data?.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Reset the state list if the error is 404
        setStateList([]);
      } else {
        console.log(error);
      }
    }
  };

  const getCityList = async (e) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}api/booking/getCityList`, { countryCode: country, stateName: stateRegion })
      setCityList(response?.data?.result)
    }
    catch (error) {
      if (error.response && error.response.status === 404) {
        setCityList([]);
      } else {
        console.log(error);
      }
    }
  }

    useEffect(() => {
      if (isDataLoaded) {
        if (role == "0") {
          setPriceRuleApplied("Admin Booking");
        } else if (role == "4") {
          setPriceRuleApplied("CS Booking");
        }
      }
    }, [ taxApplied, childSeatTotal, packagesTotal, extraTotal, fare]);
    let toastId1 = null;

  
    

  const fetchBookingDetails = async () => {
    let data = {
      bookingId: id,
    };
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getbookingdetailsbyID`,
        data
      );
      if (res.status === 200) {
        const data = res.data.data[0];
        const bookingInfo = data.booking_contact_infos[0];
        const selectedChildSeats = {};
        const selectedPackages = {};
        // booking details        
        setDatee(dayjs(data?.date));
        setMinDatee(dayjs(data?.date))
        setToLocation(data?.toLocation);
        setFromLocation(data?.fromLocation);
        //handlePlaceChange()
        setJourney(data?.bookingType);
        setCancelStatus(data?.cancelStatus);
        setBookingNo(data?.bookingId);
        setVehicleType(data?.vehicalTypeId);
        setSelectedVehicleId(data?.vehicalTypeId)
        setReturnDate(dayjs(data?.returnDate));
        setExtraTime(data?.extraTime)
        setSelectedVehicleCapacity(data?.vehicaltypes[0]?.passengersNumber)
        setPassengers(data?.passanger)
        setReturnPassengers(data?.returnPassanger)
        setReturnExtraTime(data?.returnExtraTime)
        setJourneyType(data?.bookingType);
        setDistanceKM(data?.distance);
        setFlightNum(data?.flightNumber);
        setReturnFlightNum(data?.returnFlightNumber)
        setPickupDate(dayjs.utc(data?.date).format("DD/MM/YYYY HH:mm"));
        setDuration1(data?.time);
        setRoute(data?.fromLocation + " to " + data?.toLocation);
        setTaxApplied(data?.taxPercentage)
        //setFare(data?.total)
        setPriceRuleApplied(data?.priceRuleApplied)
        setFName(bookingInfo?.fName)
        setLName(bookingInfo?.lName)
        setEmail(bookingInfo?.email)
        setNumbers( bookingInfo?.phoneCode+bookingInfo?.phoneNumber)
        setAddress(bookingInfo?.fullAddress)
        setComment(bookingInfo?.typeAnything)
        setCountryName(bookingInfo?.countryName)
        setCountry(bookingInfo?.country)
        setStateRegion(bookingInfo?.stateRegion)
        setStateName(bookingInfo?.stateName)
        setCompanyName(bookingInfo?.companyName)
        setTaxNumber(bookingInfo?.taxNumber)
        setCity(bookingInfo?.city)
        setAddress1(bookingInfo?.houseNumber)
        setAddress2(bookingInfo?.street)
        setPostal(bookingInfo?.postalCode)
        if (bookingInfo?.companyName) {
          setChecked(true);
        }
        data.booking_extra_services.forEach((item) => {
        const { serviceId, category, number } = item;

        // Find price from extra options list
        const serviceInfo = data.getExtraOption.find(opt => opt._id === serviceId);
        const price = serviceInfo?.price || 0;

        if (category === "CHILD_SEAT") {
          selectedChildSeats[serviceId] = { count: number, price };
        } else if (category === "PACKAGE") {
          selectedPackages[serviceId] = price; // only one allowed
        }
      });
      console.log("selectedChildSeats",selectedChildSeats)
      // Now set them
      setSelectedChildSeats(selectedChildSeats);
      setSelectedPackages(selectedPackages);
      handlePlaceChange2(data?.fromLocation,data?.toLocation,data?.distance,data?.time,data?.vehicalTypeId)
       }
    } catch (error) {
      console.log(error);
    }
  };


//   let valid = true;
//   let booking = "";
  const inputRef = useRef(fromLocation);
  let inputRef2 ;
  const toRef = useRef(toLocation);

  const notify = (val, type = 200) => {
    if (type === 200) {
      toast.success(val);
    } else {
      toast.error(val);
    }
  };
  
  

  //  const handlePlaceChange = () => {
  //     setShowGeoMaps(false)
  //     const place = inputRef.current?.getPlace();
  //     const placeName = place.name || place.formatted_address;
  //     if (place) {
  //       console.log("yes")
  //       if (
  //         placeName.includes("Airport") ||
  //         placeName.includes("Flughafen") ||
  //         placeName.includes("Terminal")
  //       ) {
  //         setMinDateTime(dayjs().add(30, "minutes"));
  //       } else {
  //         setMinDateTime(dayjs().add(2, "hour"));
  //       }
  //       setFromLocation(place.name);
  //       setErrorFromLocation("");
  //     } else {
        
  //       setErrorFromLocation("Invalid location selected");
  //     }
  //   };

  // const handlePlaceToChange = () => {
  //   setShowGeoMaps(false)
  //   const toPlace=toRef.current.getPlace()
  //   if (toPlace) {
  //     setToLocation(toPlace.name);
  //     setErrorToLocation("");
  //   } else {
  //     setToLocation("");
  //   }
  // };
// useEffect(() => {
//   if (!fromLocation) return;

//   // If Autocomplete hasn't loaded, or this is from API -> fallback to geocode
//   if (!inputRef.current || typeof inputRef.current.getPlace !== "function") {
//     const geocoder = new window.google.maps.Geocoder();

//     geocoder.geocode({ address: fromLocation }, (results, status) => {
//       if (status === "OK" && results[0]) {
//         const location = results[0].geometry.location;

//         setFromLocationCoords({
//           lat: location.lat(),
//           lng: location.lng(),
//         });

//         // minDateTime logic based on resolved address
//         const addressText =
//           results[0].name || results[0].formatted_address || fromLocation;

//         if (
//           addressText.toLowerCase().includes("airport") ||
//           addressText.toLowerCase().includes("flughafen") ||
//           addressText.toLowerCase().includes("terminal")
//         ) {
//           setMinDateTime(dayjs().add(30, "minute"));
//         } else {
//           setMinDateTime(dayjs().add(2.5, "hour"));
//         }
//       } else {
//         console.error("Geocoding failed:", status);
//       }
//     });
//   }
// }, [fromLocation]);

// const handlePlaceChange2=(fromLoc,toLoc,distance,duration)=>{
//   let fromLocCoords,toLocCoords;
//   const geocoder = new window.google.maps.Geocoder();
//   geocoder.geocode({ address: fromLoc }, (results, status) => {
//       if (status === "OK" && results[0]) {
//         const location = results[0].geometry.location;
//         fromLocCoords({
//           lat: location.lat(),
//           lng: location.lng(),
//         })
//         setFromLocationCoords({
//           lat: location.lat(),
//           lng: location.lng(),
//         });
//       }})

//         geocoder.geocode({ address: toLoc }, (results, status) => {
//       if (status === "OK" && results[0]) {
//         const location = results[0].geometry.location;
//         toLocCoords({
//           lat: location.lat(),
//           lng: location.lng(),
//         })
//         setToLocationCoords({
//           lat: location.lat(),
//           lng: location.lng(),
//         });}})
//         fetchData2(fromLoc,toLoc,fromLocCoords,toLocCoords, distance,duration)
        
// };

const handlePlaceChange2 = (fromLoc, toLoc, distance, duration,vehicleId) => {
  let fromLocCoords, toLocCoords;

  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode({ address: fromLoc }, (results, status) => {
    if (status === "OK" && results[0]) {
      const location = results[0].geometry.location;

      fromLocCoords = {
        lat: location.lat(),
        lng: location.lng(),
      };

      setFromLocationCoords(fromLocCoords);

      // Nested here to ensure both are done before fetchData2
      geocoder.geocode({ address: toLoc }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;

          toLocCoords = {
            lat: location.lat(),
            lng: location.lng(),
          };

          setToLocationCoords(toLocCoords);

          // ✅ Both coordinates ready, now call
          fetchData2(fromLoc, toLoc, fromLocCoords, toLocCoords, distance, duration,vehicleId);
        }
      });
    }
  });
};


const fetchData2 = async (fromLoc,toLoc,fromLocCoords,toLocCoords, distance,duration,vehicleId) => { 
        setLoading(true); 
        setLoadingTwo(true);
        //setJourneyType(journey);
        setDistanceKM(distance);
        setDuration1(duration);
        //setRoute(`${fromLocation} to ${toLocation}`);  
        //setPickupDate(dayjs.utc(datee).format('DD/MM/YYYY HH:mm'));
      
        const data = {
          fromLocation:fromLoc,
          toLocation:toLoc,
          distance:distance,
          fromLocationCoords: fromLocCoords,
          toLocationCoords: toLocCoords,
      };
      
        try {
          // Only include the getExtraClass API call if bookingId is not empty
          const promises = [axios.post(`${process.env.REACT_APP_URL}api/admin/setCompanyAgentPrice`,data)];
          promises.push(axios.get(`${process.env.REACT_APP_URL}api/admin/getExtraClass`));
  
          
          const [setPriceResponse, extraClassResponse] = await Promise.allSettled(promises);
          if (setPriceResponse?.status === 'fulfilled' && setPriceResponse?.value?.status === 200) {
            const vehiclesList = setPriceResponse?.value?.data?.result || [];
            setPriceRuleApplied(setPriceResponse?.value?.data?.condition)
            let extraClassList = [];
            if (extraClassResponse?.status === 'fulfilled' && extraClassResponse?.value?.status === 200) {
              extraClassList = extraClassResponse?.value?.data?.res || [];
            }
            if (extraClassList.length === 0) {
              console.log("No extra class data found. Check the API or data source.");
            }
            const combinedData = [...vehiclesList, ...extraClassList];
             // ✅ Set fare based on selected vehicle ID
            const selectedVehicle = vehiclesList.find(v => v._id === vehicleId);
            if (selectedVehicle) {
              setFare(selectedVehicle.price);
            }
            setVehicleList(combinedData);
            setShowGeoMaps(true)
          } else {
            console.log("One of the APIs failed");
            setLoading2(false);
            setLoadingTwo(false);
          }
        } catch (error) {
          console.error("Error occurred while fetching data:", error);
          setLoading2(false);
          setLoadingTwo(false);
        } finally {
          setLoading2(false);
          setLoadingTwo(false);
        }
      };
  const handlePlaceChange = (fromLoc) => {
      setShowGeoMaps(false)
      setShowGeoMaps2(false)
      console.log("fromLocation",inputRef.current?.getPlace())
      console.log("fromLocation 2",fromLocation)
      const place = inputRef.current?.getPlace();
      const placeName = place.name || place.formatted_address;
      if (place) {
        try {
            // Fetch coordinates using Google Maps Geocoding API
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: placeName }, (results, status) => {
              if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;
                // Set latitude and longitude in fromLocationCoords
                setFromLocationCoords({
                  lat: location.lat(),
                  lng: location.lng(),
                });
                // // Dispatch latitude and longitude to your form state
                // dispatch(updateForm({ fromLat: location.lat() }));
                // dispatch(updateForm({ fromLong: location.lng() }));
              } else {
                console.error("Geocoding failed:", status);
              }
            });
          } catch (error) {
            console.error("Geocoding error:", error);
          }
        if (
          placeName.includes("Airport") ||
          placeName.includes("Flughafen") ||
          placeName.includes("Terminal")
        ) {
          setMinDateTime(dayjs().add(30, "minutes"));
        } else {
          setMinDateTime(dayjs().add(2, "hour"));
        }
        setFromLocation(place.name);
        setErrorFromLocation("");
      } else {
        
        setErrorFromLocation("Invalid location selected");
      }
    };

    const handlePlaceToChange = () => {
    setShowGeoMaps(false)
    setShowGeoMaps2(false)
    const toPlace=toRef.current.getPlace()
    //const place = inputRef.current?.getPlace();
    const placeName = toPlace.name || toPlace.formatted_address;
    if (toPlace) {
      setToLocation(toPlace.name);
      const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: placeName }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
  
            // Set latitude and longitude in fromLocationCoords
            setToLocationCoords({
              lat: location.lat(),
              lng: location.lng(),
            });
  
            // // Dispatch latitude and longitude to your form state
            // dispatch(updateForm({ toLat: location.lat() }));
            // dispatch(updateForm({ toLong: location.lng() }));
          } else {
            console.error("Geocoding failed:", status);
          }
        });
      setErrorToLocation("");
    } else {
      setToLocation("");
    }
  };


  const handleDateChange = (newDate, placeName) => {
      if (!newDate || !newDate.isValid()) return;
      // Use the newDate as local dayjs object (don't convert to utc)
      const validDate = newDate;
    
      // Calculate minDateTime in local time
      let updatedMinDateTime = dayjs();
      if (
        fromLocation.includes("Airport") ||
        fromLocation.includes("Flughafen") ||
        fromLocation.includes("Terminal")
      ) {
        updatedMinDateTime = updatedMinDateTime.add(30, "minute");
      } else {
        updatedMinDateTime = updatedMinDateTime.add(2, "hour");
      }
    
      setMinDateTime(updatedMinDateTime);
      setDatee(validDate);
    };

  const fetchAllVehicleData = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_URL}api/vehicalType/getAllVehicalList`)
      .then(function (res) {
        setVehicleData(res.data.res || []);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const handleDuration = (callback) => {
    const directionsService = new window.google.maps.DirectionsService();
    const pickupInput = fromLocation;
    const dropoffInput = toLocation;
  
    if (!pickupInput || !dropoffInput) {
      alert("Both pickup and dropoff locations are required.");
      return;
    }
  
    const request = {
      origin: pickupInput,
      destination: dropoffInput,
      optimizeWaypoints: false,
      provideRouteAlternatives: true,
      travelMode: window.google.maps.TravelMode.DRIVING,
    };
  
    directionsService.route(request, (response, status) => {
      if (status === window.google.maps.DirectionsStatus.OK) {
        let shortestRoute = response.routes[0];
        let shortestDistance = shortestRoute.legs.reduce(
          (total, leg) => total + leg.distance.value,
          0
        );
  
        response.routes.forEach((route) => {
          const distance = route.legs.reduce(
            (total, leg) => total + leg.distance.value,
            0
          );
          if (distance < shortestDistance) {
            shortestRoute = route;
            shortestDistance = distance;
          }
        });
  
        const shortestDuration = shortestRoute.legs.reduce(
          (total, leg) => total + leg.duration.value,
          0
        );
  
        const formattedDistance = Math.ceil(shortestDistance / 1000)
          .toFixed(2)
          .toString();
        const totalMinutes = Math.floor(shortestDuration / 60);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
  
        const formattedDuration = `${hours} hours and ${minutes} mins`;
  
        callback(formattedDistance, formattedDuration); 
  
        if (window.directionsRenderer && window.finaldirectionsRenderer) {
          const modifiedResponse = { ...response, routes: [shortestRoute] };
          window.directionsRenderer.setDirections(modifiedResponse);
          window.finaldirectionsRenderer.setDirections(modifiedResponse);
        } else {
          console.error("Directions renderer is not initialized.");
        }
      } else {
        console.error("Error calculating route:", status);
      }
    });
  };

  const handleHomepage = async (e) => {
    e.preventDefault();
    let newErrors = {};
    if (!datee) {
      newErrors.datee = "Please enter Source";
    }
    // if (!vechicleType) {
    //   newErrors.vechicleType = "Please select vehicle";
    // }
    if (!journey) {
      newErrors.journey = "Please select journy type";
    }
    if (!fromLocation) {
      newErrors.fromLocation = "Please enter Source";
    }
    if (!toLocation) {
      newErrors.toLocation = "Please enter Destination";
    }
    // if (!returnDate && journey === "Return") {
    //   newErrors.returnDate = "Please enter Return Date";
    // }
    if (!returnDate && journey === "Return" && !(bookingNo?.match(/(A|B)\)$/))) {
      newErrors.returnDate = "Please enter Return Date";
    }
    if ((returnDate<minDatee) && (journey === "Return")&& !(bookingNo?.match(/(A|B)\)$/))) {
      newErrors.returnDate = "Please enter correct ReturnDate";
    }
    // if (!passengers) { newErrors.passengers = "Please enter number of passengers" }
    // if (passengers > parseInt(selectedVehicleCapacity || "0", 10)){newErrors.passengers = "No of passengers cannot exceed vehicle Capacity"}
    // if (!returnPassengers && journey === "Return") { newErrors.returnPassengers = "Please enter number of return passengers" }
    // if ((returnPassengers>parseInt(selectedVehicleCapacity || "0", 10)) && journey === "Return") { newErrors.returnPassengers = "No of passengers cannot exceed vehicle Capacity" }
    if (Object.keys(newErrors).length === 0) {
      handleDuration((distance, duration) => {
        //setPickupDate(dayjs(datee).format('DD/MM/YYYY HH:mm'));
        setJourneyType(journey);
        setDistanceKM(distance);
        setDuration1(duration);
        setRoute(fromLocation + " to " + toLocation);
        //setShowGeoMaps2(true)
         setPickupDate(datee ? dayjs(datee).format("DD/MM/YYYY HH:mm") : "")
                handleCars(distance,duration)
      });
    }
    console.log("newErrors",newErrors)
    setErrors(newErrors);
  };

  const handleCars = async(distance,duration) => {
    setShowGeoMaps2(true)
    fetchData(distance,duration)

  }
  const fetchData = async (distance,duration) => { 
        setLoading(true); 
        setLoadingTwo(true);
        setJourneyType(journey);
        setDistanceKM(distance);
        setDuration1(duration);
        setRoute(`${fromLocation} to ${toLocation}`);  
        //setPickupDate(dayjs.utc(datee).format('DD/MM/YYYY HH:mm'));
      
        const data = {
          fromLocation:fromLocation,
          toLocation:toLocation,
          distance:distance,
          fromLocationCoords: fromLocationCoords,
          toLocationCoords: toLocationCoords,
      };
      
        try {
          // Only include the getExtraClass API call if bookingId is not empty
          const promises = [axios.post(`${process.env.REACT_APP_URL}api/admin/setCompanyAgentPrice`,data)];
          promises.push(axios.get(`${process.env.REACT_APP_URL}api/admin/getExtraClass`));
  
          
          const [setPriceResponse, extraClassResponse] = await Promise.allSettled(promises);
          if (setPriceResponse?.status === 'fulfilled' && setPriceResponse?.value?.status === 200) {
            const vehiclesList = setPriceResponse?.value?.data?.result || [];
            setPriceRuleApplied(setPriceResponse?.value?.data?.condition)
            let extraClassList = [];
            if (extraClassResponse?.status === 'fulfilled' && extraClassResponse?.value?.status === 200) {
              extraClassList = extraClassResponse?.value?.data?.res || [];
            }
            if (extraClassList.length === 0) {
              console.log("No extra class data found. Check the API or data source.");
            }
            const combinedData = [...vehiclesList, ...extraClassList];
            setVehicleList(combinedData);
          } else {
            console.log("One of the APIs failed");
            setLoading2(false);
            setLoadingTwo(false);
          }
        } catch (error) {
          console.error("Error occurred while fetching data:", error);
          setLoading2(false);
          setLoadingTwo(false);
        } finally {
          setLoading2(false);
          setLoadingTwo(false);
        }
      };
  useEffect(() => {
          if (vehicleList) {
            const grouped = (vehicleList || []).reduce((acc, vehicle) => {
              const vehicleClassDetail = vehicle.vehicleClassDetail;
      
              if (!vehicleClassDetail) {
                console.error("Missing vehicleClassDetail for vehicle:", vehicle);
              }
      
              const vehicleClass = vehicleClassDetail
                ? vehicleClassDetail.vehicleClass
                : "Unknown";
      
              if (!acc[vehicleClass]) {
                acc[vehicleClass] = [];
              }
      
              acc[vehicleClass].push(vehicle);
              return acc;
            }, {});
      
            const sortedGrouped = Object.keys(grouped).reduce((acc, key) => {
              acc[key] = grouped[key].sort((a, b) => {
                const priorityA = a.vehicleClassDetail?.priority ?? 0; 
                const priorityB = b.vehicleClassDetail?.priority ?? 0;
      
                return priorityA - priorityB;
              });
              return acc;
            }, {});
      
            const sortedGroupKeys = Object.keys(sortedGrouped).sort((a, b) => {
              const minPriorityA = Math.min(
                ...sortedGrouped[a].map(
                  (item) => item.vehicleClassDetail?.priority ?? 0
                )
              );
              const minPriorityB = Math.min(
                ...sortedGrouped[b].map(
                  (item) => item.vehicleClassDetail?.priority ?? 0
                )
              );
      
              return minPriorityA - minPriorityB;
            });
            const finalSortedGrouped = sortedGroupKeys.reduce((acc, key) => {
              acc[key] = sortedGrouped[key];
              return acc;
            }, {});
      
            console.log(finalSortedGrouped);
      
            console.log("Sorted Grouped Vehicles:", finalSortedGrouped);
            setGroupedVehicles(finalSortedGrouped);
          }
        }, [vehicleList]);

  const handleClick = async (check) => {
    const distance = distanceKm
    const duration = duration1
     let updatedFare = totalFare;
    if (journey == "Return") {
      updatedFare = totalFare * 2;
    }
    const data = {
        toLocation:toLocation,
        fromLocation:fromLocation,
        date: new Date(datee).getTime(),
        returnDate: new Date(returnDate).getTime(),
        bookingType:journey,
        distance:distance,
        time:duration,
        vehicalTypeId:selectedVehicleId,
        bookingId:id,
        returnFlightNumber:returnFlightNum,
        returnExtraTime:returnExtraTime,
        returnPassanger:returnPassengers,
        returnTime:duration,
        returnDistance:distance,
        returnFromLocation:toLocation,
        returntoLocation:fromLocation,
        flightNumber:flightNum,
        passanger:passengers,
        extraTime:extraTime,
        taxPercentage:taxApplied,
        subTotal:Subtotal,
        priceRuleApplied : priceRuleApplied,
        price:rideChargesWithoutTax,
        bookingExtraTotal:bookingExtraTotal,
        tax:totalTax,
        total:updatedFare,
        comingFrom:"company/agent",
        customerEmail:email,
    }
    try {
        const res = await axios.put(
          `${process.env.REACT_APP_URL}api/booking/companyAgentEditBooking`,
          data
        );
        if (res?.status === 200) {
          setLoading(false);
          setShowGeoMaps(true);
          navigate(paths.company.dashboard);
          // if(check=="card"){
          //   //console.log("PayCheck",payCheck)
          //   handleOpen(updatedFare)
          // }
          // else if (check=="Cash" ||check=="Bank Invoice"){
          //   navigate(paths.company.dashboard);
          // }
          notify(res.msg, res.status);
        }
      } catch (error) {
        notify(error.response.data.msg, error.response.data.status);
        setLoading(false);
        console.log("i came here")
          
      }
  };

const updateBussinessAgentExtraServices=async(check)=>{
  let data = {
        bookingId: bookingId,
        childSeat:selectedChildSeats,
        packages:selectedPackages,
        extras:selectedExtras,
        //number: count,
        //action: val,
      };
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/updateBussinessAgentExtraServices`,
          data
        );
        //console.log("resadd",res)
        if (res?.data?.status === 200) {
          handleClick(check)
          
        }
      } catch (error) {
        console.log(error);
      }
}

  const handleSubmit = async (distance, duration) => {
    let data = {
      bookingId: bookingId,
      fName: fName,
      lName:lName,
      email: email,
      phoneNumber: numbers,
      companyName:companyName,
      taxNumber:taxNumber,
      city:city,
      stateRegion:stateRegion,
      country:country,
      countryName:countryName,
      stateName:stateName,
      houseNumber:address1,
      street:address2,
      postalCode:postal,
      typeAnything: comment,
      billingAddressCheck: checked,
      passanger:passengers,
      returnPassanger:returnPassengers
    };
    let newErrorDetails = {};
    if (!fName) {
      newErrorDetails.fName = "Please enter First name";
    }
    if (!lName) {
      newErrorDetails.lName = "Please enter Last name";
    }
    if (!email) {
      newErrorDetails.email = "Please enter email";
    }
    if (!numbers) {
      newErrorDetails.numbers = "Please enter mobile number";
    }
    if (!fare) {
      newErrorDetails.fare = "Please enter fare";
    }
    if (checked && companyName === "") {
      newErrorDetails.companyName = "Please enter Company Name"
    } 
    if(checked && companyName.length<2){
      newErrorDetails.companyName = "Please enter valid Company Name"};
    if(checked && companyName.length>100){
        newErrorDetails.companyName = "Company Name cannot exceed 100 letters"
      }
    if (Object.keys(newErrorDetails).length === 0) {
      setLoading(true);
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/addContactDetails`,
          data
        );
        if (res?.status === 200) {
          setLoading(false);
          notify(res.msg, res.status);
          updateBussinessAgentExtraServices()
          //handleClick();
          //navigate("/admin/dashboard");
        }
      } catch (error) {
        notify(error.response.data.msg, error.response.data.status);
        setLoading(false);
      }
    }
    setErrorDetails(newErrorDetails);
  };

  const submit = () => {
      handleSubmit();
    }
   
  const handleVehicalInfo = async (e) => {
    let data = {
      bookingId: id,
    };
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getBookedVehicalInfo`,
        data
      );
      if (res.status === 200) { 
        setVahicalInfo(res?.data?.vehicalInfo);
      }
    } catch (error) { }
  };
  const setSingleCategoryInfo = async (catId) => {
    let data = {
      _id: catId,
    };
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getSingleCategoryDetails`,
        data
      );
      if (res.status === 200) { 
        setVahicalInfo(res?.data?.data);
      }
    } catch (error) { }
  };

  // const fetchAllChildSeat = () => {
  //   setLoading(true);
  //   let totall=0;
  //   axios
  //     .post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListPhoneAndEditBooking`, {
  //       category: "CHILD_SEAT",
  //       bookingId: bookingId,
  //       distance: distanceKm,
  //       standard:vahicalInfo?.vehicalStandard,
  //       Tax:taxApplied
  //     })
  //     .then(function (res) {
  //       const sum = res?.data.data.reduce((total, item) => {
  //         if (item.flag === "1") {
  //           totall=totall+(item.number*item.price)
  //           return total + item.number;
  //         }
  //         return total;
  //       }, 0);

  //       //setGlobalNumberSum(sum);
  //       setChildSeatTotal(totall);
  //       setChildSeat(res?.data?.data || []);
  //       setLoading(false);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //       setLoading(false);
  //     });
  // };
  
//   const fetchAllChildSeat = () => {
//   setLoading(true);
//   let totall = 0;
//   axios
//     .post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListPhoneAndEditBooking`, {
//       category: "CHILD_SEAT",
//       bookingId: bookingId,
//       distance: distanceKm,
//       standard: vahicalInfo?.vehicalStandard,
//       Tax: taxApplied
//     })
//     .then(function (res) {
//       const selectedSeatState = { ...selectedChildSeats };

//       res.data.data.forEach((item) => {
//   const selected = selectedSeatState[item._id];
//   if (selected) {
//     item.number = selected.count;
//     item.price = parseFloat(selected.price); // just in case it's a string
//   } else {
//     item.number = 0;
//     item.price = parseFloat(item.price); // fallback parse
//   }
// });
      
//       totall = res.data.data.reduce((total, item) => {
//   return total + (item.number * item.price);
// }, 0);

//       console.log("totall",totall)

//       //setChildSeatTotal(totall);
//       setChildSeat(res?.data?.data || []);
//       setLoading(false);
//     })
//     .catch(function (error) {
//       console.log(error);
//       setLoading(false);
//     });
// };
const fetchAllChildSeat = () => {
    setLoading(true);
    let totall=0;
    axios
    .post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListBusinessAgent`, {
      category: "CHILD_SEAT",
      bookingId: bookingId,
      Tax:taxApplied
      
    })
    .then(function (res) {
      const sum = res?.data.data.reduce((total, item) => {
        if (item.flag === "1") {
          totall=totall+(item.number*item.price)
          return total + item.number;
        }
        return total;
      }, 0);
      //setGlobalNumberSum(sum);
      setChildSeatTotal(totall);
      setChildSeat(res?.data?.data || []);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
    });
    
  };

  // const fetchAllPackage = async () => {
  //   let extraObj = {
  //     category: "PACKAGE",
  //     bookingId: bookingId,
  //     distance: distanceKm,
  //     standard:vahicalInfo?.vehicalStandard,
  //     Tax:taxApplied
  //   };
  //   let totall3=0;
  //   try {
  //     const res = await axios.post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListPhoneAndEditBooking`,
  //       extraObj
  //     );
  //     res?.data?.data.find((item) => {
  //       if (item.flag == "1") {
  //         totall3=item.price
  //       }
  //   })
  //   setPackagesTotal(totall3)
  //     setPackages(res?.data.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

const fetchAllPackage = async () => {
  let extraObj = {
    category: "PACKAGE",
    bookingId: bookingId,
    distance: distanceKm,
    standard: vahicalInfo?.vehicalStandard,
    Tax: taxApplied
  };
  let totall3 = 0;
  try {
    const res = await axios.post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListBusinessAgent`,
      extraObj
    );

    const selectedPkgState = { ...selectedPackages };

    res.data.data.forEach((item) => {
      if (selectedPkgState[item._id]) {
        item.flag = "1"; // reflect active selection
        totall3 = item.price;
      } else {
        item.flag = "0";
      }
    });

    setPackagesTotal(totall3);
    setPackages(res?.data.data || []);
  } catch (error) {
    console.log(error);
  }
};


//   const fetchAllExtra = () => {
//     setLoading(true);
//     let totall2=0;
//     axios
//       .post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListBusinessAgent`, {
//         category: "EXTRA",
//         bookingId: bookingId,
//         distance: distanceKm,
//         standard:vahicalInfo?.vehicalStandard,
//         Tax:taxApplied
//       })
//       .then(function (res) {
//         const selectedExtras = {};

// res?.data.data.forEach((item) => {
//   selectedExtras[item._id] = item.price;
// });

// setSelectedExtras(selectedExtras);
//         const sum = res?.data.data.reduce((total, item) => {
//           if (item.flag === "1") {
//             totall2=totall2+item.price
//           }
//       })
//         setExtraTotal(totall2)
//         setExtra(res?.data?.data || []);
//         setLoading(false);
//       })
//       .catch(function (error) {
//         console.log(error);
//         setLoading(false);
//       });
//   };

  const fetchAllExtra = () => {
  setLoading(true);
  let totall2 = 0;
  axios
    .post(`${process.env.REACT_APP_URL}api/extraOption/getExtraOptionListBusinessAgent`, {
      category: "EXTRA",
      bookingId: bookingId,
      distance: distanceKm,
      standard: vahicalInfo?.vehicalStandard,
      Tax: taxApplied
    })
    .then(function (res) {
      const selectedExtras = {};
      res?.data.data.forEach((item) => {
        if (item.flag === "1") {
          selectedExtras[item._id] = item.price;
          totall2 += item.price;
        }
      });
      setSelectedExtras(selectedExtras);
      setExtraTotal(totall2);
      setExtra(res?.data?.data || []);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
    });
};


  const handleJourney = (event) => {
    setJourney(event.target.value);
    setShowGeoMaps(false);
    setShowGeoMaps2(false)
  };
  const handleVehicleType = (event) => {
    setSingleCategoryInfo(event.target.value)
    setVehicleType(event.target.value);
    setShowGeoMaps(false);
    const matchedVehicle = vehicleData.find(
      (vehicle) => vehicle._id === event.target.value
    );
  
    setSelectedVehicleCapacity(matchedVehicle?.passengersNumber);
    setPassengers("")
    setReturnPassengers("")
  
  };

  // const handleSelect = async (service_id, val, count) => {
  //   if(globalNumberSum+count>((vahicalInfo?.passengersNumber)-1)&&val==1 ){
  //     if (!toast.isActive(toastId1)) {
  //       toastId1 = toast.error("Can't add more than vehicle seat capacity and one seat is reserved for adult")
  //     }
  //     return;
  //   }
  //   else{
  //     let data = {
  //       bookingId: bookingId,
  //       serviceId: service_id,
  //       number: count,
  //       action: val,
  //     };
  //     try {
  //       const res = await axios.post(
  //         `${process.env.REACT_APP_URL}api/booking/addExtraServices`,
  //         data
  //       );
  //       if (res?.data?.status === 200) {
  //         fetchAllChildSeat();
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
    
  // };

const maxChildSeats = passengers - 1;
console.log("maxChildSeats",maxChildSeats)
const globalNumberSum = Object.values(selectedChildSeats).reduce(
  (sum, item) => sum + item.count,
  0
);
//   let globalNumberSum;
// useEffect(()=>{
// globalNumberSum = Object.values(selectedChildSeats).reduce(
//   (sum, item) => sum + item.count,
//   0
// );
// },[selectedChildSeats])
useEffect(()=>{
  console.log("globalNumberSum",globalNumberSum)

},[globalNumberSum])

const isMaxReached = globalNumberSum >= (passengers - 1);
console.log("isMaxReached",isMaxReached)

  const handleSelect = async (serviceId, val, count, price) => {

  if (!serviceId || typeof count !== "number" || count < 0) return;
    console.log("here",globalNumberSum,maxChildSeats,val)

  if (globalNumberSum > maxChildSeats && val === 1) {
    console.log("i am here")
    if (!toast.isActive(toastId1)) {
      toastId1 = toast.error(
        "Can't add more than vehicle seat capacity. One seat is reserved for adult."
      );
    }
    return;
  }

  setSelectedChildSeats(prev => {
    const updated = { ...prev };
    if (count === 0) {
      delete updated[serviceId];
    } else {
      updated[serviceId] = { count, price };
    }
    return updated;
  });  
  };

  const totalChildSeatPrice = Object.values(selectedChildSeats).reduce(
  (sum, item) => sum + item.count * item.price,
  0
);

 useEffect(()=>{
    console.log("childSeatCounts",selectedChildSeats)
    console.log("childSeatCounts total",totalChildSeatPrice)
    setChildSeatTotal(totalChildSeatPrice)
  },[selectedChildSeats])

// useEffect(()=>{
//     setSelectedChildSeats({})
//     setSelectedPackages({})
//     setSelectedExtras({})
//     console.log("childSeatCounts Cap",passengers)

//   },[passengers])

  // const handleSelectService = async (service_id, val) => {
  //   let data = {
  //     bookingId: bookingId,
  //     serviceId: service_id,
  //     number: "",
  //     action: val,
  //     previousServiceID:""
  //   };
  //   let data2 = {
  //     bookingId: bookingId,
  //     serviceId: service_id,
  //     number: "",
  //     action:val,
  //     previousServiceID:prevServ
  //   };
  //   if((prevServ=="" & val==1)||(prevServ!=="" & val==1)){
  //     if(prevServ==""){
  //         setPrevServ(service_id)
  //         try {
  //           const res = await axios.post(
  //             `${process.env.REACT_APP_URL}api/booking/addPackageService`,
  //             data
  //           );
            
            
  //           if (res?.data?.status === 200) {
  //             fetchAllPackage();
  //           }
  //         } catch (error) {
  //           console.log(error);
  //         }
  //       }
  //       else if(prevServ!==""){
  //         setPrevServ(service_id)
  //         try {
  //           const res = await axios.post(
  //             `${process.env.REACT_APP_URL}api/booking/addPackageService`,
  //             data2
  //           );
  
  //           if (res?.data?.status === 200) {
  //             fetchAllPackage();
  //           }
  //         } catch (error) {
  //           console.log(error);
  //         }
  //       }
     
  //   }
  //   else if((prevServ!==""&&val==0)|| (prevServ==""&&val==0)){
  //     try {
  //       const res = await axios.post(
  //         `${process.env.REACT_APP_URL}api/booking/addPackageService`,
  //         data2
  //       );
  //       if (res?.data?.status === 200) {
  //         fetchAllPackage();
  //         val=1
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }

  // };

  const handleSelectService = (serviceId, action, price) => {
  setSelectedPackages(prev => {
    if (action === 1) {
      // Select only this one, clear others
      return { [serviceId]: price };
    } else {
      // Unselect everything (reset object)
      return {};
    }
  });
};
const totalPackagePrice = Object.values(selectedPackages).reduce(
  (sum, price) => sum + price,
  0
  );

   useEffect(()=>{
    console.log("setSelectedPackages", selectedPackages)
    console.log("setSelectedPackages Total", totalPackagePrice)
    setPackagesTotal(totalPackagePrice)
    
  },[selectedPackages])
  // const handleExtraService = async (service_id, val) => {
  //   let data = {
  //     bookingId: bookingId,
  //     serviceId: service_id,
  //     number: "",
  //     action: val,
  //   };
  //   try {
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_URL}api/booking/addExtraServices`,
  //       data
  //     );
  //     if (res?.data?.status === 200) {
  //       fetchAllExtra();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleExtraService = async (service_id, action, price) => {
    console.log("handleExtraService",service_id,"/",action,"/",price)

    setSelectedExtras(prev => {
    const updated = { ...prev };

    if (action === 1) {
      updated[service_id] = price; // ✅ Select
    } else {
      delete updated[service_id]; // ❌ Unselect
    }

    return updated;
  });}
const totalExtrasPrice = Object.values(selectedExtras).reduce(
  (sum, price) => sum + price,
  0
);

useEffect(()=>{
  console.log("selectedExtras",selectedExtras)
  console.log("selectedExtras total",totalExtrasPrice)
  setExtraTotal(totalExtrasPrice)
},[selectedExtras])


  useEffect(() => {
    setBookingId(id)
    fetchAllVehicleData();
    fetchBookingDetails();
    handleVehicalInfo();
  }, []);
  useEffect(()=>{
    fetchAllChildSeat();
    fetchAllExtra();
    fetchAllPackage();
    setIsDataLoaded(true);
  },[distanceKm,vechicleType,vahicalInfo,taxApplied])
  useEffect(() => {
    if (
      !fromLocation.toLowerCase().includes("airport") &&
      !fromLocation.toLowerCase().includes("flughafen") &&
      !fromLocation.toLowerCase().includes("terminal")
    ) {
      setFlightNum(0);
    }
  }, [fromLocation]);
  useEffect(() => {
    if (
      !toLocation.toLowerCase().includes("airport") &&
      !toLocation.toLowerCase().includes("flughafen") &&
      !toLocation.toLowerCase().includes("terminal") &&
      journeyType!=="Return"
    ) {
      setReturnFlightNum(0);
      setReturnDate(0)
    }
  }, [toLocation]);

  useEffect(() => {
    const parseTravelTime = (timeString) => {
      if (!timeString) return 0;  
      const match = timeString.match(/(\d+)\s*hours?\s*(?:and\s*)?(\d+)?\s*mins?/);
      const hours = match && match[1] ? parseInt(match[1]) : 0;
      const minutes = match && match[2] ? parseInt(match[2]) : 0;
      return hours * 60 + minutes; 
    };
  
    const parseExtraTime = (extraTimeString) => {
      const match = extraTimeString.match(/(\d+)\s*(hours?|min)/);
      const value = match && match[1] ? parseInt(match[1]) : 0;
      if (match && match[2] === "hours") {
        return value * 60; 
      }
      return value; 
    };
  
    const pickDateTime = dayjs(datee);
    const travelMinutes = parseTravelTime(duration1);
    const extraMinutes = parseExtraTime(extraTime);
  

    const minDates = pickDateTime.add(travelMinutes + extraMinutes, "minute");
    setMinDatee(dayjs(minDates));
  }, [datee, duration1, extraTime]);
  

  const minDateTimes = dayjs(minDatee).minute(minDatee.minute()).second(minDatee.second());
   useEffect(()=>{
    if(journey=="One Way"){
      setReturnDate(null)
      setReturnExtraTime("");
        }
      },[journey])


          useEffect(()=>{
            
            setBookingExtraTotal(childSeatTotal+packagesTotal+extraTotal)
          },[childSeatTotal,packagesTotal,extraTotal])
          useEffect(()=>{
            let temp=0;
            temp=bookingExtraTotal/(1+(taxApplied/100))
            setBookingExtraWithoutTax((temp).toFixed(2))
            setBookingExtraTaxAm((bookingExtraTotal-temp).toFixed(2))
          },[bookingExtraTotal,taxApplied])
          useEffect(() => {
            if (!fare) {
              setRideChargesWithoutTax(0);
              setRideChargesTaxAm(0);
            } else {
              console.log("what")
              const updatedRideCharges = fare;
          
              const updatedRideChargesWithoutTax = updatedRideCharges / (1 + taxApplied / 100);
          
              const updatedRideChargesTaxAm = updatedRideCharges - updatedRideChargesWithoutTax;
              setRideCharges(updatedRideCharges);
              console.log("updatedRideCharges",updatedRideCharges)
              console.log("updatedRideChargesWithoutTax",updatedRideChargesWithoutTax)
              console.log("updatedRideChargesTaxAm",updatedRideChargesTaxAm)

              setRideChargesWithoutTax(updatedRideChargesWithoutTax.toFixed(2)); 
              setRideChargesTaxAm(updatedRideChargesTaxAm.toFixed(2)); 
            } 
          }, [fare, bookingExtraTotal, taxApplied]);
      
          useEffect(() => {
            let temp = parseFloat(rideChargesWithoutTax) + parseFloat(bookingExtraWithoutTax);
            setSubTotal(parseFloat(temp.toFixed(2))); 
          }, [rideChargesWithoutTax, bookingExtraWithoutTax]);
          useEffect(()=>{
            let temp1;
            temp1=parseFloat(bookingExtraTaxAm)+parseFloat(rideChargesTaxAm)
            setTotalTax(parseFloat(temp1.toFixed(2)))
          },[bookingExtraTaxAm,rideChargesTaxAm])

           useEffect(() => {
              if(!checked){
                setCompanyName("");
                setTaxNumber("");
                setCountry("");
                setStateRegion("");
                setCountryName("");
                setStateName("");
                setAddress1("");
                setAddress2("");
                setCity("")
                setPostal("")
              }
            }, [checked]);

            useEffect(() => {
  const localNow = dayjs();
const fakedUtc = dayjs.utc(
  `${localNow.format("YYYY-MM-DD")}T${localNow.format("HH:mm")}:00Z`
); // 👈 Treat local time *as if* it were UTC

let adjustedUtc;

if (
  fromLocation.includes("Airport") ||
  fromLocation.includes("Flughafen") ||
  fromLocation.includes("Terminal")
) {
  adjustedUtc = fakedUtc.add(30, "minute");
} else {
  adjustedUtc = fakedUtc.add(2, "hour");
}

//console.log("🕓 Final UTC minDateTime:", adjustedUtc.format()); // shows correct UTC time
setMinDateTime(adjustedUtc);
}, [fromLocation]);

const handleDialog = (currentValue) => {
      setQuoteDialog(true);
      setFormData({...formData, vehicleCategory: currentValue?.vehicalName, vehicleCapacity:currentValue?.passengersNumber , luggageCapacity:currentValue?.suitcasesNumber });
    };

 const handleCarSelect = async (currentValue) => {
        console.log("currentValueHS",currentValue)
        setPassengers(parseFloat(currentValue?.passengersNumber))
        setFare(currentValue?.price)
        if(journey=="Return"){
        setReturnPassengers(parseFloat(currentValue?.passengersNumber));
        }
        else{
          setReturnPassengers(0)
        }
        setShowGeoMaps(true)

      };

      useEffect(()=>{
          if (!showGeoMaps2){
            setSelectedVehicleId(null);
          }
      },[showGeoMaps2])

      useEffect(() => {
        const safeFare = parseFloat(fare) || 0;
        const safeExtra = parseFloat(bookingExtraTotal) || 0;
      
        setTotalFare((safeFare + safeExtra).toFixed(2));
      }, [fare, bookingExtraTotal]);
      
      // useEffect(() => {
      //   const safeReturnFare = parseFloat(totalFare*2) || 0;
        
      //   if(journey=="Return"){
      //     setTotalReturnFare((safeReturnFare).toFixed(2));
      //   }
      //   else{
      //     setTotalReturnFare((0).toFixed(2));
      //   }
      // }, [fare, bookingExtraTotal,journey]);

    useEffect(()=>{
      if(!selectedVehicleId){
        setFare(0)
        console.log("ride1")
      } 
    },[selectedVehicleId])
    useEffect(()=>{
        if(selectedVehicleId==null){
          setShowGeoMaps(false) // unselect
    
        }
    
      },[selectedVehicleId])

    useEffect(()=>{
      console.log("journeyType",journeyType)
    },[journeyType])
    useEffect(()=>{
      console.log("datee",datee)
    },[datee])

 useEffect(() => {
  if (Object.keys(errorDetails).length > 0) {
    if (errorDetails.fName && fNameRef.current) {
      fNameRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      fNameRef.current.focus();
    } else if (errorDetails.lName && lNameRef.current) {
      lNameRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      lNameRef.current.focus();
    } else if (errorDetails.email && emailRef.current) {
      emailRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      emailRef.current.focus();
    } else if (errorDetails.numbers && phoneRef.current) {
      phoneRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      phoneRef.current.focus();
    } 
  }
}, [errorDetails, errors]);

useEffect(()=>{
  console.log("selectedVehicle",selectedVehicleId)
},[selectedVehicleId])

  return (
    <>
      <div className="container-fluid container-main">
        <Box sx={{ p: 3 }}>
          <div className="top-heading mb-4">Edit Booking</div>
          <Paper className="p-3 pe-4">
            <div className="page-heading">Ride Details</div>

            <div className="row my-1">
              <div className="col-md-6 pe-4">
                
                <div className="div-100 border mb-4 px-3 pt-2"  
                style={
                    paymentType !== "Cash"
                      ? { opacity: 0.7, pointerEvents: "none", cursor: "default" }
                      : {}
                    }
                >
                  <label className="label-admin-text" htmlFor="address">
                    From
                  </label>
                   <Autocomplete
                    onLoad={(ref) => (inputRef.current = ref)}
                    onPlaceChanged={
                      handlePlaceChange
                      }
                      // types={["(regions)"]}
                      // options={{
                      //   types: ["(regions)"],
                      //   componentRestrictions: { country: "DE" }, // Replace 'DE' with the desired country code
                      // }}
                      types='(geocode)'
                  
                      options={{
                      types: ["geocode", "establishment"],
                      componentRestrictions:
                      { country: [
                          "de",
                          "at",
                          "be",
                          "bg",
                          "cy",
                          "cz",
                          "dk",
                          "ee",
                          "es",
                          "fi",
                          "fr",
                          "gr",
                          "hr",
                          "hu",
                          "ie",
                          "it",
                          "lt",
                          "lu",
                          "lv",
                          "mt",
                          "nl",
                          "pl",
                          "pt",
                          "ro",
                          "se",
                          "si",
                          "sk",
                          ],
                           },
                          fields: [
                          "destination",
                          "formatted_address",
                          "address_components",
                          "geometry",
                          "types",
                          "name",
                          ],
                          }}
                          
                        >
                        <TextField
                        sx={{
                        border: "none",
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                        "& > fieldset": {
                        border: "none",
                        },
                       },
                      }}
                      type="address"
                      id="address"
                      name="address"
                      className="text-admin"
                      value={fromLocation}
                      onChange={(e) => {
                        setFromLocation(e.target.value);
                        setShowGeoMaps(false);
                      }}
                      error={errors.fromLocation}
                      helperText={errors.fromLocation}
                      placeholder="Enter Pick Up Location"
                      inputProps={
                          paymentType !== "Cash" ? { readOnly: true } : {}
                        }
                        onFocus={
                          paymentType !== "Cash"
                            ? (e) => e.target.blur()
                            : undefined
                        }
                        onClick={
                          paymentType !== "Cash"
                            ? (e) => e.preventDefault()
                            : undefined
                        }
                      />
                  </Autocomplete>
                </div>
                <div className="col-md-12 mb-4 px-3 pt-2 border" 
                style={
                    paymentType !== "Cash"
                      ? { opacity: 0.7, pointerEvents: "none", cursor: "default" }
                      : {}
                    }
                >
                  <label className="label-admin-text" htmlFor="address">
                    To
                  </label>
                  <Autocomplete
                    onLoad={(ref) => (toRef.current = ref)}
                    onPlaceChanged={() =>
                    handlePlaceToChange()
                    }
                    // types={["(regions)"]}
                    // options={{
                    //   types: ["(regions)"],
                    //   componentRestrictions: { country: "DE" }, // Replace 'US' with the desired country code
                    // }}
                    types='(geocode)'
                    options={{
                    types: ["geocode", "establishment"],
                    componentRestrictions: { 
                      country: [
                        "de",
                        "at",
                        "be",
                        "bg",
                        "cy",
                        "cz",
                        "dk",
                        "ee",
                        "es",
                        "fi",
                        "fr",
                        "gr",
                        "hr",
                        "hu",
                        "ie",
                        "it",
                        "lt",
                        "lu",
                        "lv",
                        "mt",
                        "nl",
                        "pl",
                        "pt",
                        "ro",
                        "se",
                        "si",
                        "sk",
                        ],
                      },
                    fields: [
                      "destination",
                      "formatted_address",
                      "address_components",
                      "geometry",
                      "types",
                      "name",
                      ],
                  }}
                >
                  <TextField
                    sx={{
                      border: "none",
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                      "& > fieldset": {
                      border: "none",
                      },
                      },
                      }}
                    type="address"
                    id="address"
                    name="address"
                    value={toLocation}
                    onChange={(e) => {setToLocation(e.target.value);
                      setShowGeoMaps(false)
                    }}
                    error={errors.toLocation}
                    helperText={errors.toLocation}
                    className="text-admin"
                    placeholder="Enter Drop Off Location"
                    inputProps={
                          paymentType !== "Cash" ? { readOnly: true } : {}
                        }
                        onFocus={
                          paymentType !== "Cash"
                            ? (e) => e.target.blur()
                            : undefined
                        }
                        onClick={
                          paymentType !== "Cash"
                            ? (e) => e.preventDefault()
                            : undefined
                        }
                  />
                </Autocomplete>
                </div>
                <div className="row mb-2 w-100" >
                <div className="w-100 mb-4 overflow-hidden p-0">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DateTimePicker"]}>
                      <MobileDateTimePicker
                        format="DD/MM/YYYY HH:mm"
                        label="Pickup Date & Time"
                        value={dayjs.utc(datee)}
                        minDateTime={minDateTime}
                        onChange={(newValue) => {
                            setShowGeoMaps(false);
                            setShowGeoMaps2(false);
                            setDatee(newValue);
                            handleDateChange()
                          
                        }}
                        //minDate={minDate}
                        maxDate={maxDate}
                        ampm={false}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                {/* <div className=" ">
                      
                      <FormControl fullWidth>
                      
                      <InputLabel >Extra Time</InputLabel>
                        <Select
                        sx={{
                          "@media (max-width:  820px)": {
                            "& .MuiInputBase-input": {
                              paddingLeft:"30px",
                            },
                          },
                        }}
                          label="Extra Time"
                          onChange={(e) => {
                            setExtraTime(e.target.value);
                            setShowGeoMaps(false);
                          }}
                          value={extraTime}
                          size="small"
                        >
                          
                          <MenuItem value="0">0</MenuItem>
                          <MenuItem value="30 min">30 min</MenuItem>
                          <MenuItem value="1 hours">1 hours</MenuItem>
                          <MenuItem value="2 hours">2 hours</MenuItem>
                          <MenuItem value="3 hours">3 hours</MenuItem>
                        </Select>
                      </FormControl>
                    </div> */}
                
                </div>
                
                {/* <div className="w-100 mb-4">
                  <Box>
                    <FormControl fullWidth size="small" error={!!errors.tax}>
                      <InputLabel>Tax %</InputLabel>
                      <Select
                        label="Tax %"
                        value={taxApplied}
                        onChange={(event) => {setTaxApplied(event.target.value)
                          setShowGeoMaps(false)
                        }} // Directly setting the value here
                      >
                        <MenuItem value={1}>1%</MenuItem>
                        <MenuItem value={2}>2%</MenuItem>
                        <MenuItem value={3}>3%</MenuItem>
                        <MenuItem value={4}>4%</MenuItem>
                        <MenuItem value={5}>5%</MenuItem>
                        <MenuItem value={6}>6%</MenuItem>
                        <MenuItem value={7}>7%</MenuItem>
                        <MenuItem value={8}>8%</MenuItem>
                        <MenuItem value={9}>1%</MenuItem>
                        <MenuItem value={10}>10%</MenuItem>
                        <MenuItem value={11}>11%</MenuItem>
                        <MenuItem value={12}>12%</MenuItem>
                        <MenuItem value={13}>13%</MenuItem>
                        <MenuItem value={14}>14%</MenuItem>
                        <MenuItem value={15}>15%</MenuItem>
                        <MenuItem value={16}>16%</MenuItem>
                        <MenuItem value={17}>17%</MenuItem>
                        <MenuItem value={18}>18%</MenuItem>
                        <MenuItem value={19}>19%</MenuItem>
                        <MenuItem value={20}>20%</MenuItem>
                        <MenuItem value={21}>21%</MenuItem>
                        <MenuItem value={22}>22%</MenuItem>
                        <MenuItem value={23}>23%</MenuItem>
                        <MenuItem value={24}>24%</MenuItem>
                        <MenuItem value={25}>25%</MenuItem>
                        
                      </Select>
                      {errors.tax && <FormHelperText>{errors.tax}</FormHelperText>}
                    </FormControl>
                  </Box>
                </div> */}
  {/*style={{opacity: 0.7, pointerEvents: "none", cursor: "default"}} */}
                <div className="row mb-3 w-100 p-0" 
                style={
                  paymentType !== "Cash"
                    ? { opacity: 0.7, pointerEvents: "none", cursor: "default" }
                    : {}
                  }
                >
                  <div className="row mb-2 w-100 p-0">
                    <Box sx={{padding:0}}>
                      
                      <FormControl
                        fullWidth
                        size="small"
                        error={errors.journey}
                      >
                        <InputLabel id="JOURNEY TYPE">Journey Type</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          value={journey}
                          label="Journey Type"
                          onChange={handleJourney}
                          //open={false}
                          // onOpen={(e) => e.preventDefault()}
                          // onClick={(e) => e.preventDefault()}
                          // onFocus={(e) => e.target.blur()}
                          // readOnly={true}
                        >
                          <MenuItem value={"One Way"}>One Way</MenuItem>
                          <MenuItem value={"Return"}>Return</MenuItem>
                        </Select>
                        {errors.journey && (
                          <FormHelperText>{errors.journey}</FormHelperText>
                        )}
                        
                      </FormControl>
                    </Box>
                  </div>
                  {/* <div className="col-md-6 ">
                    <Box>
                      <FormControl
                        fullWidth
                        size="small"
                        error={errors.vechicleType}
                      >
                        <InputLabel id="JOURNEY TYPE">Vehicle Type</InputLabel>
                        <Select
                          value={vechicleType}
                          label="Vehicle Type"
                          onChange={handleVehicleType}
                          renderValue={(selected) => {
                            const selectedVehicle = vehicleData?.find((v) => v._id === selected);
                            return selectedVehicle ? (
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                <span>{selectedVehicle?.vehicalName}</span>
                                <span style={{ fontSize: "0.9rem", opacity: 0.8 }}>
                                  ({selectedVehicle?.passengersNumber} P • {selectedVehicle?.suitcasesNumber} B)
                                </span>
                              </div>
                            ) : (
                              selected
                            );
                          }}
                        >
                          {vehicleData?.map((curElem, i) => {
                            return (
                              <MenuItem value={curElem._id} 
                              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                              <span>{curElem?.vehicalName}</span> 
                              <span style={{ fontSize: "0.9rem", opacity: 0.8,alignItems:"end"  }}>
                                ({curElem?.passengersNumber} P • {curElem?.suitcasesNumber} B)
                              </span>                 
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {errors.vechicleType && (
                          <FormHelperText>{errors.vechicleType}</FormHelperText>
                        )}
                      </FormControl>
                    </Box>
                  </div> */}
                </div>
                {/* <div className="w-100 mb-4">
                  <TextField
                  id="Passengers"
                  fullWidth
                  type="number"
                  size="small"
                  label="Passengers"
                  value={passengers}
                  onChange={(e) =>{
                  setShowGeoMaps(false)
                  setPassengers(e.target.value)
                  }}
                  //inputProps={{ min: 1, max: 99 }}
                  error={!!errors.passengers}
                  helperText={errors.passengers}
                  />
                </div> */}
                {journey === "Return" && (
        !/(A|B)\)$/.test(bookingNo) ? (
            <>
            <div className="w-100 mb-4 overflow-hidden">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DateTimePicker"]}>
                    <MobileDateTimePicker
                    label="Return Date & Time"
                    value={returnDate}
                    onChange={(newValue) => {
                        setReturnDate(newValue);
                        setShowGeoMaps(false);
                        setShowGeoMaps2(false);
                    }}
                    minDateTime={minDatee}
                    maxDate={maxDate}
                    ampm={false}
                    onError={errors.returnDate}
                    />
                </DemoContainer>
        </LocalizationProvider>
      </div>
      {/* <div className="w-100 mb-4">
        <TextField
          fullWidth
          type="number"
          size="small"
          label="Return Passengers"
          value={returnPassengers}
          onChange={(e) =>{
            setShowGeoMaps(false)
            setReturnPassengers(e.target.value)
          }}
          //inputProps={{ min: 1, max: 99 }}
          error={!!errors.returnPassengers}
          helperText={errors.returnPassengers}
        />
        </div> */}
      {/* <div className="w-100 mb-4">
        <FormControl fullWidth>
          <InputLabel>Return Extra Time</InputLabel>
          <Select
            sx={{
              "@media (max-width: 820px)": {
                "& .MuiInputBase-input": {
                  paddingLeft: "30px",
                },
              },
            }}
            label="Return Extra Time"
            onChange={(e) => {
              setReturnExtraTime(e.target.value);
              setShowGeoMaps(false);
            }}
            value={returnExtraTime}
            size="small"
          >
            <MenuItem value="0">0</MenuItem>
            <MenuItem value="30 min">30 min</MenuItem>
            <MenuItem value="1 hours">1 hours</MenuItem>
            <MenuItem value="2 hours">2 hours</MenuItem>
            <MenuItem value="3 hours">3 hours</MenuItem>
          </Select>
        </FormControl>
      </div> */}
    </>
  ) : null
)}

                <Button
                  variant="contained"
                  className="px-4"
                  onClick={handleHomepage}
                >
                  Select Vehicle
                </Button>
              </div>

              <div className="col-md-6 white-card border p-3 mb-5" style={{opacity: 0.7, pointerEvents: "none", cursor: "default"}}>
                <table className="table table-bordered" width="100%">
                  <tr>
                    <th className="px-2 text-admin table-th">Payment Type</th>
                    <td className="text-admin">
                      <TextField
                        inputProps={{ readOnly: true }}
                        sx={{
                          border: "none",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        type="text"
                        value={paymentType}
                        //onChange={(e) => setJourneyType(e.target.value)}
                        placeholder="xx"
                        className="text-admin"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="px-2 text-admin table-th">Journey Type</th>
                    <td className="text-admin">
                      <TextField
                        inputProps={{ readOnly: true }}
                        sx={{
                          border: "none",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        type="text"
                        value={journeyType}
                        //onChange={(e) => setJourneyType(e.target.value)}
                        placeholder="xx"
                        className="text-admin"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="px-2 text-admin table-th">
                      Distance in Kilometer
                    </th>
                    <td className="text-admin">
                      <TextField
                        inputProps={{ readOnly: true }}
                        sx={{
                          border: "none",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        type="text"
                        value={distanceKm}
                        onChange={(e) => setDistanceKM(e.target.value)}
                        placeholder="xx"
                        className="text-admin"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="px-2 text-admin table-th">
                      Pickup Date & Time
                    </th>
                    <td className="text-admin">
                      <TextField
                        sx={{
                          border: "none",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        inputProps={{ readOnly: true }}
                        type="text"
                        value={pickUpDate}
                        onChange={(e) => setPickupDate(e.target.value)}
                        placeholder="xx"
                        className="text-admin"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="px-2 text-admin table-th">Duration</th>
                    <td className="text-admin">
                      <TextField
                        inputProps={{ readOnly: true }}
                        multiline
                        sx={{
                          border: "none",
                          width: "100%",
                          overflow: "none",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        type="text"
                        value={duration1}
                        onChange={(e) => setDuration1(e.target.value)}
                        placeholder="xx"
                        className="text-admin"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="px-2 text-admin table-th">Route</th>
                    <td className="text-admin">
                      <TextField
                        inputProps={{ readOnly: true }}
                        multiline
                        sx={{
                          border: "none",
                          width: "100%",
                          overflow: "none",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        type="text"
                        value={route}
                        onChange={(e) => setRoute(e.target.value)}
                        placeholder="xx"
                        className="text-admin"
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          {showGeoMaps2 && (
          <div className="col-md-9 p-2" 
                      style={
                            paymentType !== "Cash"
                              ? { opacity: 0.7, pointerEvents: "none", cursor: "default" }
                              : {}
                          }
          >
            <h5 className="px-3" 
              style={
                    paymentType !== "Cash"
                      ? { opacity: 0.7, pointerEvents: "none", cursor: "default" }
                      : {}
                  }
            >
              Vehicle List (One Way Price){" "}
              <span style={{ fontSize: "14px" }}>tax incuded*</span>
            </h5>
            <div>
              <div className="col-md-11 col-sm-6 my-3 forVehicleImage">
                {Object.keys(groupedVehicles).length > 0 ? (
                  Object.keys(groupedVehicles).map((vehicleClass, index) => (
                    <div key={index}>
                      {/* Vehicle Class Header */}
                      <h3 className="mt-4">{vehicleClass}</h3>

                      {/* Render vehicles for this class */}
                      {groupedVehicles[vehicleClass].map((currentValue) => (
                        <div
                          className="card mt-2 white-card"
                          key={currentValue._id}
                        >
                          <div className="card-body">
                            <Grid container>
                              {/* Vehicle Image */}
                              <Grid item md={5} xm={4} textAlign="center">
                                <div>
                                  <img
                                    src={currentValue?.vehicalImage}
                                    alt="Card image cap"
                                    onError={(e) => {
                                      e.target.src = Scorpio;
                                    }}
                                    style={{
                                      width: "100%",
                                      height: "12rem",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              </Grid>

                              {/* Vehicle Details */}
                              <Grid item md={5} xm={4} spacing={2}>
                                <div className="p-2">
                                  <label className="vehicle-type mt-1">
                                    {currentValue?.vehicalStandard}
                                  </label>
                                  <div className="d-flex flex-wrap gap-2 mt-2">
                                    <div className="d-flex justify-content-center gap-2">
                                      <div>
                                        <img src={user} className="" />
                                      </div>
                                      <div>
                                        <p className="people-bag">
                                          {currentValue?.passengersNumber}{" "}
                                          People
                                        </p>
                                      </div>
                                    </div>
                                    <div className="d-flex gap-2 justify-content-center">
                                      <div>
                                        <img src={bag} />
                                      </div>
                                      <div>
                                        <p className="people-bag">
                                          {currentValue?.suitcasesNumber} Bag
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <p className="vehicle-card-text">
                                    {currentValue?.vehicalModel &&
                                      `${currentValue?.vehicalModel}, `}
                                    {currentValue?.vehicalName &&
                                      `${currentValue?.vehicalName}, `}
                                    {currentValue?.company}
                                  </p>
                                </div>
                              </Grid>

                              {currentValue?.vehicleClassDetail?.onCall &&
                              currentValue?.vehicleClassDetail?.onCall ===
                                true ? (
                                <Grid
                                  item
                                  md={2}
                                  textAlign="center"
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <button
                                    className="btn-select py-2 px-3"
                                    onClick={() => handleDialog(currentValue)}
                                  >
                                    Get a Quote
                                  </button>
                                </Grid>
                              ) : (
                                <Grid item md={2} textAlign="center">
                                  <div className="mt-4">
                                    <p className="veh-price">
                                      {parseFloat(currentValue?.price).toFixed(
                                        2
                                      )}{" "}
                                      &#8364;
                                    </p>
                                    <div>
                                      
                                        <button
                                          className="btn-select py-2 px-3"
                                          onClick={() =>{
                                            if (selectedVehicleId === currentValue._id) {
                                              setSelectedVehicleId(null); // unselect
                                            } else {
                                              setSelectedVehicleId(currentValue._id); // select

                                            }
                                            handleCarSelect(currentValue)
                                            setTaxApplied(currentValue.tax)
                                            console.log("currentValue",currentValue)
                                          }
                                          }
                                          style={
                                              selectedVehicleId === currentValue._id
                                                ? {
                                                    backgroundColor: "#0E4672",
                                                    color: "white",
                                                    // border: "1px solid #0E4672",
                                                  }
                                                : {}
                                            }
                                            inputProps={
                                                paymentType !== "Cash" ? { readOnly: true } : {}
                                              }
                                              onFocus={
                                                paymentType !== "Cash"
                                                  ? (e) => e.target.blur()
                                                  : undefined
                                              }
                                        >
                                          {selectedVehicleId === currentValue._id ? "Selected" : "Select"}
                                        </button>
                                    
                                    </div>
                                  </div>
                                </Grid>
                              )}
                            </Grid>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))
                ) : (loading === false && loadingTwo === false) ? (
                  <p>No vehicle found</p>
                ) : (
                  <p>Loading....</p>
                )}
              </div>
            </div>
          </div>
)}
            {showGeoMaps && (
            <div>
              <div className="col-md-12 heading-section">Customer Details</div>

              <div className="row my-3 gap-1 px-3">
                <div className="col-md-5 white-card p-3 border">
                  <label className="label-admin-text" htmlFor="name">
                    First Name*
                  </label>
                  <TextField
                    sx={{
                      border: "none",
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& > fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    inputRef={fNameRef}
                    type="name"
                    id="name"
                    name="name"
                    value={fName}
                    onChange={(e) => setFName(e.target.value)}
                    className="text-admin"
                    placeholder="First Name"
                    error={errorDetails.fName}
                    helperText={errorDetails.fName}
                    inputProps={{
                      maxLength: 100,
                      pattern: "[A-Za-z\\s]*", 
                      onKeyPress: (e) => {
                      if (!/^[A-Za-z\s\-]*$/.test(e.key)) {
                      e.preventDefault(); 
                      }},
                    }}
                  />
                </div>
                <div className="col-md-5 white-card p-3 border">
                  <label className="label-admin-text" htmlFor="name">
                    Last Name*
                  </label>
                  <TextField
                    sx={{
                      border: "none",
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& > fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    inputRef={lNameRef}
                    type="name"
                    id="name"
                    name="name"
                    value={lName}
                    onChange={(e) => setLName(e.target.value)}
                    className="text-admin"
                    placeholder="Last Name"
                    error={errorDetails.lName}
                    helperText={errorDetails.lName}
                    inputProps={{
                      maxLength: 100,
                      pattern: "[A-Za-z\\s]*", 
                      onKeyPress: (e) => {
                      if (!/^[A-Za-z\s\-]*$/.test(e.key)) {
                      e.preventDefault();
                      }},
                    }}
                  />
                </div>
                <div className="col-md-5 white-card p-3 border">
                  <label className="label-admin-text" htmlFor="email" ref={emailRef}>
                    E-mail Address*
                  </label>
                  <TextField
                    sx={{
                      border: "none",
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& > fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    // inputRef={emailRef}
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="text-admin"
                    placeholder="E-mail Adresse"
                    error={errorDetails.email}
                    helperText={errorDetails.email}
                  />
                </div>
                <div className="col-md-5 white-card p-3 border">
                  <label className="label-admin-text" ref={phoneRef}>Telefonummer*</label>
                  <br />
                  <div>
                    <PhoneInput
                      style={{
                        border: "none",
                        width: "75%",
                        "& .MuiOutlinedInput-root": {
                          "& > fieldset": {
                            border: "none",
                          },
                        },
                      }}
                      country={"de"}
                      value={numbers}
                      onChange={(phone) => setNumbers(phone)}
                    />
                    {errorDetails.numbers && (
                      <small style={{ color: "#d32f2f", fontWeight: 400 }}>
                        {errorDetails.numbers}
                      </small>
                    )}
                  </div>
                 
                </div>
                {(fromLocation.toLowerCase().includes("airport") || 
                    fromLocation.toLowerCase().includes("flughafen") || 
                    fromLocation.toLowerCase().includes("terminal")) && (
                    <div className="col-md-5 white-card p-3 border">
                      <label className="label-admin-text">Flight Number</label>
                      <TextField
                        sx={{
                          border: "none",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={flightNum}
                        onChange={(e) => setFlightNum(e.target.value)}
                        className="text-admin"
                        placeholder="Enter Flight Number"
                      />
                    </div>
                  )}
                  {((toLocation.toLowerCase().includes("airport") || 
                    toLocation.toLowerCase().includes("flughafen") || 
                    toLocation.toLowerCase().includes("terminal"))&& journeyType=="Return") && (
                    <div className="col-md-5 white-card p-3 border">
                      <label className="label-admin-text">Return Flight Number</label>
                      <TextField
                        sx={{
                          border: "none",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "& > fieldset": {
                              border: "none",
                            },
                          },
                        }}
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={returnFlightNum}
                        onChange={(e) => setReturnFlightNum(e.target.value)}
                        className="text-admin"
                        placeholder="Enter Return Flight Number"
                        inputProps={{maxLength:25}}
                      />
                    </div>
                  )}
               <Grid item xs={12} sm={12} md={12} className="content-fields">
                                   <FormControlLabel
                                     control={
                                       <Checkbox checked={checked} onChange={handleChange}/>
                                       }
                                     label="Billing Address"
                                   />
                                 </Grid>
                                 {checked && (
                                 <div className="  ">
                                   <div >
                                     <h6 style={{ color: '#1F3648' }}>Billing Address</h6>
                                   </div>
                                   <div className="card-body">
                                     <div className="mt-3">
                                       <AddressFormWrapper>
                                         <Grid container>
                                           <Grid item xs={12} sm={6} md={6} className="content-fields">
                                           <TextField
                                               fullWidth
                                               label="Company Name/Customer Name*"
                                               variant="outlined"
                                               value={companyName}
                                               error={errorDetails.companyName}
                                               helperText={errorDetails.companyName}
                                               //onChange={(e) => setCompanyName(e.target.value)}
                                               onChange={(e) => {
                                                 setCompanyName(e.target.value);
                                               }}
                                               //inputProps={{ maxLength: 250 }}
               
                                             />
                                           </Grid>
                                           <Grid item xs={12} sm={6} md={6} className="content-fields">
                                           <TextField
                                             label="Tax Number"
                                             variant="outlined"
                                             fullWidth
                                             value={taxNumber}
                                             onChange={(e) => {
                                               const value = e.target.value;
                                               // Allow only alphanumeric characters
                                               const sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, "");
                                               setTaxNumber(sanitizedValue);
                                             }}
                                             error={!!taxNumberErrorText}
                                             helperText={taxNumberErrorText}
                                             inputProps={{ maxLength: 15 }}
                                             />
                                           </Grid>
                                           <Grid item xs={12} sm={6} md={4} className="content-fields">
                                             <select
                                               style={{ border:"none", width:"100%", height:"100%" }}
                                               onChange={(e) => {
                                                 const selectedOption = countryList.find(
                                                   (item) => item.isoCode === e.target.value
                                                 );
                                                 setCountry(e.target.value);
                                                 setCountryName(selectedOption?.name || "");
                                               }}
                                               value={country}
                                             >
                                               <option>Select Country</option>
               
                                               {countryList?.length > 0 &&
                                                 countryList?.map((currentValue) => {
                                                   return (
                                                     <option value={currentValue.isoCode}>
                                                       {currentValue.name}
                                                     </option>
                                                   );
                                                 })}
                                             </select>
               
                                           </Grid>
                                           <Grid item xs={12} sm={6} md={4} className="content-fields">
                                               <select
                                                 style={{ width: "100%", height: "40px", border: "none" }} // Set a fixed height
                                                 disabled={!country || countryList.length === 0 || stateList.length == 0}
                                                 value={stateRegion}
                                                 onChange={(e) => {
                                                   const selectedOption = stateList.find(
                                                     (item) => item.isoCode === e.target.value
                                                   );
                                                   setStateRegion(e.target.value);
                                                   setStateName(selectedOption?.name || "");
                                                 }}                                >
                                                 <option>State or Region</option>
                                                 {stateList?.length > 0 &&
                                                   stateList?.map((currentValue, i) => {
                                                     return (
                                                       <option key={i} value={currentValue.isoCode}>{currentValue.name}</option>
                                                     );
                                                   })}
                                               </select>
                                             </Grid>
                                           <Grid item xs={12} sm={6} md={4} className="content-fields">
                                             <select
                                               style={{ width:"100%", height:"100%", border:"none" }}
                                               disabled={!stateRegion || stateList.length === 0 || cityList.length === 0}
                                               value={city}
                                               onChange={(e) => setCity(e.target.value)}
                                             >
                                               <option>City</option>
               
                                               {cityList?.length > 0 &&
                                                 cityList?.map((currentValue, i) => {
                                                   return (
                                                     <option value={currentValue.isoCode}>{currentValue.name}</option>
                                                   )
                                                 })}
                                             </select>
                                           </Grid>
                                           <Grid item xs={12} sm={6} md={4} className="content-fields">
                                             <TextField
                                               fullWidth
                                               label="House Number"
                                               variant="outlined"
                                               value={address1}
                                               onChange={(e) => {
                                                 const value = e.target.value;
                                                 // Allow only alphanumeric characters
                                                 const sanitizedValue = value.replace(/[^a-zA-Z0-9 ]/g, "");
                                                 setAddress1(sanitizedValue);
                                               }}
                                               inputProps={{ maxLength: 100 }}
               
                                             />
                                           </Grid>
                                           <Grid item xs={12} sm={6} md={4} className="content-fields">
                                             <TextField
                                               fullWidth
                                               label="Street Name"
                                               variant="outlined"
                                               value={address2}
                                               onChange={(e) => {
                                                 const value = e.target.value;
                                                 // Allow only alphanumeric characters
                                                 const sanitizedValue = value.replace(/[^a-zA-Z0-9 ]/g, "");
                                                 setAddress2(sanitizedValue);
                                               }}
                                               inputProps={{ maxLength: 100 }}
               
                                             />
                                           </Grid>
                                           <Grid item xs={12} sm={6} md={4} className="content-fields">
                                             <TextField
                                               fullWidth
                                               label="Postal Code"
                                               variant="outlined"
                                               value={postal}
                                               onChange={(e) => {
                                                 const value = e.target.value;
                                                 // Allow only alphanumeric characters
                                                 const sanitizedValue = value.replace(/[^a-zA-Z0-9\s\- ]/g, "");
                                                 setPostal(sanitizedValue);
                                               }}
                                               inputProps={{maxLength:10}}
                                             />
                                           </Grid>
                                         </Grid>
                                       </AddressFormWrapper>
                                     </div>
                                   </div>
                                 </div>
                               )}
                
              </div>
              <div className="col-md-12 heading-section my-">Booking Extra (Tax Applied: {taxApplied}%)</div>
                <div className="row gap-5 my-4 p-2 m-2 ">
                  <div className="col-md-5 border white-card p-1" 
                      style={
                      paymentType !== "Cash"
                        ? { opacity: 0.7, pointerEvents: "none", cursor: "default" }
                        : {}
                    }
                  >
                    <div className="label-text ">
                      {" "}
                      <img
                        src={emoji}
                        width="50px"
                        style={{ marginRight: "10px" }}
                      />
                      Child Seat
                    </div>
                    <hr />
                    <div className="row border-bottom mx-2">
                      {/* <div className='col-md-8 text-admin'>Baby Seat (0 Months - 9 Months)</div>
                                        <div className='col-md-1 pb-2 label-text mt-auto'>{babySeatCount}</div>
                                        <div className='col-md-3'>
                                            <div className='rounded-pill d-flex'>
                                                <button className='w-50 puls-minus-btn-darkblue' onClick={handleBabySeatIncrement}>+</button>
                                                <button className='w-50 puls-minus-btn-skyblue' onClick={handleBabySeatDecrement}>-</button>
                                            </div>
                                        </div> */}
                      {childSeat?.length > 0 &&
                        // childSeat.map((currentValue, i) => {
                        //   return (
                        //     <AgentSubChild
                        //       currentValue={currentValue}
                        //       handleSelect={handleSelect}
                        //       globalNumberSum={globalNumberSum}
                        //       passengers={passengers}
                        //     />
                        //   );
                        // })
                        childSeat.map((currentValue, i) => {
                          return (
                            <EditAgentSubChild
                              key={currentValue._id}
                               currentValue={{
                                  ...currentValue,
                                  number: selectedChildSeats?.[currentValue._id]?.count || 0
                                }}
                              handleSelect={handleSelect}
                              //globalNumberSum={globalNumberSum}
                              isMaxReached={isMaxReached}
                              passengers={passengers}
                              paymentType={paymentType}
                            />
                          );
                        })
                        }
                    </div>
                  </div>
                  <div className="col-md-5 border white-card  p-3 " 
                    style={
                    paymentType !== "Cash"
                      ? { opacity: 0.7, pointerEvents: "none", cursor: "default" }
                      : {}
                    }
                  >
                    <div className="label-text ">
                      {" "}
                      <img
                        src={pakage}
                        width="40px"
                        style={{ marginRight: "10px" }}
                      />
                      Package
                    </div>
                    <hr />
                    <div className="row mx-2">
                      {packages?.length > 0 &&
                        packages?.map((currentValue, i) => (
                          <Table
                            sx={{ minWidth: 400 }}
                            aria-label="simple table"
                          >
                            <TableRow
                              className="py-1"
                              key={i}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                className="fw-bold"
                                component="th"
                                scope="row"
                              >
                                <div className="fs-5 child-text">
                                  {currentValue.type}
                                </div>
                                <div>{currentValue.fame}</div>
                                <div>{currentValue.desc}</div>
                                <div className="child-price">
                                  {" "}
                                  &euro; {currentValue.price}
                                </div>
                              </TableCell>
                              {/* <TableCell className="fw-bold bluetext fs-4" align="left">
                                                &euro; {currentValue.price}
                                            </TableCell> */}
                              <TableCell className="fw-bold" align="right">
                                {/* {currentValue.flag === "1" ? (
                                  <Button
                                    variant="contained"
                                    onClick={() =>
                                      handleSelectService(currentValue._id, 0)
                                    }
                                  >
                                    Selected <CheckIcon />
                                  </Button>
                                  
                                ) : (
                                  <Button
                                    variant="outlined"
                                    onClick={() =>
                                      handleSelectService(currentValue._id, 1)
                                    }
                                  >
                                    Select
                                  </Button>
                                 
                                )} */}
                                {selectedPackages[currentValue?._id] ? (
                                  <Button
                                    variant="contained"
                                    onClick={() => handleSelectService(currentValue._id, 0)}
                                    // inputProps={{readOnly:true}}
                                    // onFocus={(e) => e.target.blur()} // prevents cursor/focus
                                    // onClick={(e) => e.preventDefault()}
                                  >
                                    Selected <CheckIcon />
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outlined"
                                    onClick={() =>
                                      handleSelectService(currentValue._id, 1, currentValue?.price)
                                    }
                                    // inputProps={{readOnly:true}}
                                    // onFocus={(e) => e.target.blur()} // prevents cursor/focus
                                    // onClick={(e) => e.preventDefault()}
                                  >
                                    Select
                                  </Button>
                                )}
                              </TableCell>
                            </TableRow>
                          </Table>
                        ))}
                    </div>
                    <hr />
                  </div>
                  <div className="col-md-5 border white-card" 
                      style={
                      paymentType !== "Cash"
                        ? { opacity: 0.7, pointerEvents: "none", cursor: "default" }
                        : {}
                    }
                  >
                    <div className="label-text ">
                      {" "}
                      <img
                        src={disability1}
                        width="40px"
                        style={{ marginRight: "10px" }}
                      />
                      Extras
                    </div>
                    <hr />
                    <div className="row mx-2">
                      {extra?.length > 0 &&
                        extra.map((currentValue, i) => (
                          <TableRow
                            className="py-1"
                            key={i}
                            sx={{
                              "& td, & th": { borderBottom: "none" },
                            }}
                          >
                            <TableCell
                              className="fw-bold"
                              component="th"
                              scope="row"
                            >
                              <div className="fs-6 fw-bold">
                                {currentValue.type}
                              </div>
                              <div className="fs-5 fw-bold bluetext">
                                &euro;{currentValue.price}
                              </div>
                            </TableCell>
                            <TableCell className="fw-bold" align="right">
                              {/* {selectedExtraServices.includes(currentValue) ? ( */}
                              {/* {currentValue.flag === "1" ? (
                                <Button
                                  variant="contained"
                                  onClick={() =>
                                    handleExtraService(currentValue._id, 0)
                                  }
                                >
                                  Selected <CheckIcon />
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  onClick={() =>
                                    handleExtraService(currentValue._id, 1)
                                  }
                                >
                                  Select
                                </Button>
                              )} */}
                              {selectedExtras.hasOwnProperty(currentValue._id) ? (
                                  <Button
                                    variant="contained"
                                    onClick={() => handleExtraService(currentValue?._id, 0,0)}
                                    // inputProps={{readOnly:true}}
                                    // onFocus={(e) => e.target.blur()} // prevents cursor/focus
                                    // onClick={(e) => e.preventDefault()}
                                  >
                                    Selected <CheckIcon />
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outlined"
                                    onClick={() =>
                                      handleExtraService(currentValue?._id, 1, currentValue?.price)
                                    }
                                    // inputProps={{readOnly:true}}
                                    // onFocus={(e) => e.target.blur()} // prevents cursor/focus
                                    // onClick={(e) => e.preventDefault()}
                                  >
                                    Select
                                  </Button>
                                )}
                              {/* )} */}
                            </TableCell>
                          </TableRow>
                        ))}
                    </div>
                    <hr />
                  </div>

                  <div className="col-md-5 border white-card" style={{opacity: 0.7, pointerEvents: "none", cursor: "default"}}>
                    <div className="label-text ">
                      Booking Extra Total With Tax
                    </div>
                    <hr />
                    <div className="row mx-2">
                      <TableRow
                        className="py-1"
                        sx={{
                          "& td, & th": { borderBottom: "none" },
                        }}
                      >
                        <TableCell
                          className="fw-bold"
                          component="th"
                          scope="row"
                        >
                          <div className="fs-6 fw-bold">Child Seat Total:</div>
                          <div className="fs-5 fw-bold bluetext">
                            &euro;{(childSeatTotal || 0).toFixed(2)}
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        className="py-1"
                        sx={{
                          "& td, & th": { borderBottom: "none" },
                        }}
                      >
                        <TableCell
                          className="fw-bold"
                          component="th"
                          scope="row"
                        >
                          <div className="fs-6 fw-bold">Package Total:</div>
                          <div className="fs-5 fw-bold bluetext">
                            &euro;{(packagesTotal || 0).toFixed(2)}
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        className="py-1"
                        sx={{
                          "& td, & th": { borderBottom: "none" },
                        }}
                      >
                        <TableCell
                          className="fw-bold"
                          component="th"
                          scope="row"
                        >
                          <div className="fs-6 fw-bold">Extras Total:</div>
                          <div className="fs-5 fw-bold bluetext">
                            &euro;{(extraTotal || 0).toFixed(2)}
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        className="py-1"
                        sx={{
                          "& td, & th": { borderBottom: "none" },
                        }}
                      >
                        <TableCell
                          className="fw-bold"
                          component="th"
                          scope="row"
                        >
                          <div className="fs-6 fw-bold">Total:</div>
                          <div className="fs-5 fw-bold bluetext">
                            &euro;{(bookingExtraTotal || 0).toFixed(2)}(one way)
                          </div>
                        </TableCell>
                      </TableRow>
                    </div>
                    <hr />
                  </div>
                </div>
              <div className="col-md-12 heading-section my-">Comments</div>
              <div className="col-md-12 my-4 m-2">
                <div class="form-floating">
                  <textarea
                    class="form-control"
                    placeholder="Leave a comment here"
                    id="floatingTextarea"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  ></textarea>
                  <label for="floatingTextarea">Comments</label>
                </div>
                <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "10px",
                                      margin: "10px 0",
                                      opacity: 0.7, pointerEvents: "none", cursor: "default"
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: "1 1 calc(50% - 10px)",
                                        minWidth: "300px",
                                        boxSizing: "border-box",
                                      }}
                                      className="border"
                                    >
                                      <label className="label-admin-text" >
                                        Extra Options Without Tax
                                      </label>
                                      <TextField
                                        sx={{
                                          border: "none",
                                          width: "100%",
                                          "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                              border: "none",
                                            },
                                          },
                                        }}
                                        value={bookingExtraWithoutTax}
                                        className="text-admin"
                                        InputProps={{ readOnly: true }}
                                      />
                                    </div>
                
                                    <div
                                      style={{
                                        flex: "1 1 calc(50% - 10px)",
                                        minWidth: "300px",
                                        boxSizing: "border-box",
                                      }}
                                      className="border"
                                    >
                                      <label className="label-admin-text">
                                        Extra Options Tax Amount
                                      </label>
                                      <TextField
                                        sx={{
                                          border: "none",
                                          width: "100%",
                                          "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                              border: "none",
                                            },
                                          },
                                        }}
                                        value={bookingExtraTaxAm}
                                        className="text-admin"
                                        InputProps={{ readOnly: true }}
                                      />
                                    </div>
                
                                    <div
                                      style={{
                                        flex: "1 1 calc(50% - 10px)",
                                        minWidth: "300px",
                                        boxSizing: "border-box",
                                      }}
                                      className="border"
                                    >
                                      <label className="label-admin-text">
                                        Ride Charges Without Tax
                                      </label>
                                      <TextField
                                        sx={{
                                          border: "none",
                                          width: "100%",
                                          "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                              border: "none",
                                            },
                                          },
                                        }}
                                        value={rideChargesWithoutTax}
                                        className="text-admin"
                                        InputProps={{ readOnly: true }}

                                      />
                                    </div>
                
                                    <div
                                      style={{
                                        flex: "1 1 calc(50% - 10px)",
                                        minWidth: "300px",
                                        boxSizing: "border-box",
                                      }}
                                      className="border"
                                    >
                                      <label className="label-admin-text">
                                        Tax Amount on Ride Charges
                                      </label>
                                      <TextField
                                        sx={{
                                          border: "none",
                                          width: "100%",
                                          "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                              border: "none",
                                            },
                                          },
                                        }}
                                        value={rideChargesTaxAm}
                                        className="text-admin"
                                        InputProps={{ readOnly: true }}

                                      />
                                    </div>
                
                                    <div
                                      style={{
                                        flex: "1 1 calc(50% - 10px)",
                                        minWidth: "300px",
                                        boxSizing: "border-box",
                                      }}
                                      className="border"
                                    >
                                      <label className="label-admin-text">
                                        Subtotal Without Tax
                                      </label>
                                      <TextField
                                        sx={{
                                          border: "none",
                                          width: "100%",
                                          "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                              border: "none",
                                            },
                                          },
                                        }}
                                        value={Subtotal}
                                        className="text-admin"
                                        InputProps={{ readOnly: true }}

                                      />
                                    </div>
                
                                    <div
                                      style={{
                                        flex: "1 1 calc(50% - 10px)",
                                        minWidth: "300px",
                                        boxSizing: "border-box",
                                      }}
                                      className="border"
                                    >
                                      <label className="label-admin-text">
                                        Total Tax
                                      </label>
                                      <TextField
                                        sx={{
                                          border: "none",
                                          width: "100%",
                                          "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                              border: "none",
                                            },
                                          },
                                        }}
                                        value={totalTax}
                                        className="text-admin"
                                        InputProps={{ readOnly: true }}

                                      />
                                    </div>
                                  </div>
                <div className="col-md-12 my-2 p-2 border" style={{opacity: 0.7, pointerEvents: "none", cursor: "default"}}>
                  <label className="label-admin-text">
                    Fare 
                  </label>
                  <TextField
                    sx={{
                      border: "none",
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& > fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    type="address"
                    id="address"
                    name="address"
                    value={totalFare}
                    // onChange={(e) => {
                    //   const inputValue = e.target.value;
                    //   if (/^\d*\.?\d*$/.test(inputValue)) {
                    //     //setFare(inputValue);
                    //   }
                    // }}
                    className="text-admin"
                    placeholder="Fare"
                    error={errorDetails.fare}
                    helperText={errorDetails.fare}
                    inputProps={{maxLength:50,
                    pattern: "[0-9.]*",
                    readOnly: true 
                    }}
                  />
                </div>
                 {journey === "Return" && (
                                  <div className="col-md-12 my-2 p-2 border" style={{opacity: 0.7, pointerEvents: "none", cursor: "default"}}>
                                    <label className="label-admin-text" htmlFor="address">
                                      Fare (Return fare)
                                    </label>
                                    <TextField
                                      sx={{
                                        border: "none",
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                          "& > fieldset": {
                                            border: "none",
                                          },
                                        },
                                      }}
                                      type="address"
                                      id="address"
                                      name="address"
                                      value={journey === "Return" ? totalFare * 2 : 0}
                                      onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if (/^\d*\.?\d*$/.test(inputValue)) {
                                          setFare(inputValue);
                                          setErrorDetails((prev) => ({
                                            ...prev,
                                            fare: "",
                                          }));
                                        }
                                      }}
                                      onBlur={() => {
                                        if (fare && Number(fare) < bookingExtraTotal) {
                                          setErrorDetails((prev) => ({
                                            ...prev,
                                            fare: `Fare cannot be less than ${bookingExtraTotal}`,
                                          }));
                                        } else {
                                          setErrorDetails((prev) => ({
                                            ...prev,
                                            fare: "",
                                          }));
                                        }
                                      }}
                                      className="text-admin"
                                      placeholder="Fare"
                                      error={errorDetails.fare}
                                      helperText={errorDetails.fare}
                                      inputProps={{ maxLength: 50, pattern: "[0-9.]*",readOnly: true }}
                                    />
                                  </div>
                                  )}
              </div>
              <button
                className="btn-primary w-auto mx-3 px-5 mb-5"
                onClick={submit}
              >
                Submit
              </button>
            </div>
            )}
          </Paper>
        </Box>
      </div>
    </>
  );
}
